/* Product options, quantity and modal controls; adapted from original theme.js. */
(()=>{
const productOptionsCl = {
popup: "product-popup-js",
popupOverlay: "product-popup-overlay-js",
popupCloseBtn: "product-popup-close-js",
popupConfirmBtn: "product-popup-confirm-button-js",
popupOpenEl: "product-popup-open-js",
colorRadio: "product-popup-radio-js",
quantityWrapper: "product-quantity-wrapper-js",
quantityInput: "product-options-quantity-input-js",
quantityPlusBtn: "product-quantity-plus-js",
quantityMinusBtn: "product-quantity-minus-js",
strengthWrapper: "product-strength-wrapper-js",
strengthRadio: "product-strength-radio-js",
priceTag: "product-options-price-js",
basketBtn: "product-options-basket-btn-js"
};
const resetProductQuantity = function(quantityInput) {
quantityInput.value = 1;
quantityInput.setAttribute("value", 1);
};
const switchPriceTag = function(chosenVariant) {
const priceTags = document.querySelectorAll("." + productOptionsCl.priceTag);
priceTags.forEach((tag)=>{
const tagMoneyEl = tag.querySelector(".money") || tag;
const previousPrice = tag.getAttribute("data-total-price");
if (tag.hasAttribute("original-price")) {
tag.setAttribute("data-total-price", chosenVariant.getAttribute("data-variant-original-price"));
tag.setAttribute("data-product-price", chosenVariant.getAttribute("data-variant-original-price"));
tag.setAttribute("data-product-price-currency", chosenVariant.getAttribute("data-variant-original-price-currency"));
tagMoneyEl.textContent = tagMoneyEl.textContent.replace(previousPrice, tag.getAttribute("data-product-price"));
return;
}
tag.setAttribute("data-total-price", chosenVariant.getAttribute("data-variant-price"));
tag.setAttribute("data-product-price", chosenVariant.getAttribute("data-variant-price"));
tag.setAttribute("data-product-price-currency", chosenVariant.getAttribute("data-variant-price-currency"));
tagMoneyEl.textContent = tagMoneyEl.textContent.replace(previousPrice, tag.getAttribute("data-product-price"));
});
};
const calculatePriceTag = function(action = "plus", quantity = 1) {
const priceTags = document.querySelectorAll("." + productOptionsCl.priceTag);
const renderNewPrice = function(priceTag, previousTotalStr, newTotal) {
const tagMoneyEl = priceTag.querySelector(".money") || priceTag;
priceTag.setAttribute("data-total-price", newTotal.toFixed(2));
tagMoneyEl.textContent = tagMoneyEl.textContent.replace(previousTotalStr, newTotal.toFixed(2));
};
priceTags.forEach((tag)=>{
const previousTotalStr = tag.getAttribute("data-total-price");
const previousTotal = +tag.getAttribute("data-total-price");
const productPrice = +tag.getAttribute("data-product-price");
let newTotal;
if (action === "plus") {
newTotal = previousTotal + productPrice * quantity;
renderNewPrice(tag, previousTotalStr, newTotal);
} else if (action === "minus") {
newTotal = previousTotal - productPrice * quantity;
renderNewPrice(tag, previousTotalStr, newTotal);
} else if (action === "manual") {
newTotal = productPrice * quantity;
renderNewPrice(tag, previousTotalStr, newTotal);
}
});
};
const updateProductQuantity = function(quantityInput, action = "plus") {
const currentQuantity = +quantityInput.value;
let newQuantity;
if (action === "plus") {
newQuantity = currentQuantity + 1;
quantityInput.value = newQuantity;
quantityInput.setAttribute("value", newQuantity);
calculatePriceTag();
} else if (action === "minus" && currentQuantity > 1) {
newQuantity = currentQuantity - 1;
quantityInput.value = newQuantity;
quantityInput.setAttribute("value", newQuantity);
calculatePriceTag("minus");
} else if (action === "manual") {
newQuantity = currentQuantity;
quantityInput.value = newQuantity;
quantityInput.setAttribute("value", newQuantity);
calculatePriceTag("manual", newQuantity);
}
};
const addQuantityEvents = function(quantityWrapper) {
const quantityInput = quantityWrapper.querySelector("." + productOptionsCl.quantityInput);
const basketBtn = document.querySelector("." + productOptionsCl.basketBtn);
quantityWrapper.addEventListener("click", (e)=>{
if (e.target.closest("." + productOptionsCl.quantityPlusBtn)) updateProductQuantity(quantityInput);
if (e.target.closest("." + productOptionsCl.quantityMinusBtn)) updateProductQuantity(quantityInput, "minus");
});
quantityInput.addEventListener("keyup", (e)=>{
if (e.target.value < 1) e.target.value = 1;
updateProductQuantity(quantityInput, "manual");
});
};
const initProductQuantity = function() {
const quantityWrapper = document.querySelector("." + productOptionsCl.quantityWrapper);
if (!quantityWrapper) return;
addQuantityEvents(quantityWrapper);
};
const hideProductPopup = function(currentPopup) {
currentPopup.removeAttribute("active");
};
const showProductPopup = function(popup) {
popup.setAttribute("active", "");
};
const updateDropdown = function(dropdownInput, clickedRadio, quantityInput) {
dropdownInput.value = `${clickedRadio.getAttribute("data-colour-option")}`;
dropdownInput.setAttribute("filled", "");
resetProductQuantity(quantityInput);
switchPriceTag(clickedRadio);
};
const addPopupEvents = function(openEl, quantityInput) {
const popup = openEl.closest("." + productOptionsCl.popupOpenEl).nextElementSibling;
const dropdownInput = openEl.querySelector("input");
const checkedRadio = popup.querySelector("input[checked]");
if (checkedRadio) dropdownInput.value = checkedRadio.value;
dropdownInput.setAttribute("filled", "");
openEl.addEventListener("click", (e)=>{
showProductPopup(popup);
});
popup.addEventListener("click", (e)=>{
if (e.target.closest("button." + productOptionsCl.popupCloseBtn) || e.target.closest("button." + productOptionsCl.popupConfirmBtn) || e.target.classList.contains(productOptionsCl.popupOverlay)) hideProductPopup(popup);
if (e.target.closest("." + productOptionsCl.colorRadio)) {
const radio = e.target.closest("." + productOptionsCl.colorRadio).querySelector("input");
hideProductPopup(popup);
if (radio.hasAttribute("out-of-stock")) return;
document.querySelector("." + productOptionsCl.basketBtn).disabled = false;
updateDropdown(dropdownInput, radio, quantityInput);
}
});
};
const initProductPopup = function() {
const openPopupEls = document.querySelectorAll("." + productOptionsCl.popupOpenEl);
if (openPopupEls.length < 1) return;
const quantityInput = document.querySelector("." + productOptionsCl.quantityInput);
openPopupEls.forEach((openEl)=>{
addPopupEvents(openEl, quantityInput);
});
};
const addStrengthEvents = function(strengthWrapper, strengthRadios, quantityInput) {
strengthWrapper.addEventListener("click", (e)=>{
if (e.target.closest("." + productOptionsCl.strengthRadio)) {
const radioInput = e.target.closest("." + productOptionsCl.strengthRadio).querySelector("input");
if (radioInput.hasAttribute("disabled")) return;
resetProductQuantity(quantityInput);
switchPriceTag(radioInput);
let _variant = radioInput.value;
if (_variant == "10mg") {
document.querySelectorAll(".product-popup-radio-js input.twenty-only").forEach((f)=>{
f.parentElement.classList.add("hidden");
});
document.querySelectorAll(".product-popup-radio-js input").forEach((f)=>{
f.classList.add("filtered");
});
document.querySelectorAll(".product-popup-radio-js input.ten-only").forEach((f)=>{
f.parentElement.classList.remove("hidden");
});
}
if (_variant == "20mg") {
document.querySelectorAll(".product-popup-radio-js input.twenty-only").forEach((f)=>{
f.parentElement.classList.remove("hidden");
});
document.querySelectorAll(".product-popup-radio-js input").forEach((f)=>{
if (f.dataset.variant2Inventory <= 0 && f.dataset.variantInventory > 0 && f.classList.contains("filtered")) f.parentElement.removeAttribute("out-of-stock");
f.classList.remove("filtered");
});
document.querySelectorAll(".product-popup-radio-js input.ten-only").forEach((f)=>{
f.parentElement.classList.add("hidden");
});
}
}
});
};
const initProductStrength = function() {
const strengthWrapper = document.querySelector("." + productOptionsCl.strengthWrapper);
if (!strengthWrapper) return;
const strengthRadios = [
...strengthWrapper.querySelectorAll("." + productOptionsCl.strengthRadio)
];
const quantityInput = document.querySelector("." + productOptionsCl.quantityInput);
addStrengthEvents(strengthWrapper, strengthRadios, quantityInput);
};
initProductQuantity(); initProductPopup(); initProductStrength();
})();

/* Related products popup; adapted from original theme.js. */
(()=>{
const relatedProductsCl = {
wrapper: "related-products-wrapper-js",
cardBtn: "card-product-small-button-js",
popup: "related-products-popup-js",
popupOverlay: "related-products-popup-overlay-js",
popupCloseBtn: "related-products-popup-close-js",
quantityInputWrapper: "related-products-popup-quantity-input-wrapper-js",
quantityInput: "related-products-popup-quantity-input-js",
quantityPlusBtn: "related-products-popup-quantity-plus-js",
quantityMinusBtn: "related-products-popup-quantity-minus-js",
basketBtn: "related-products-popup-basket-btn-js",
radio: "related-products-popup-radio-js",
product: "related-products-popup-product-js",
priceTag: "related-products-popup-price-js"
};
const switchPriceTag = function(chosenVariant) {
const priceTags = chosenVariant.closest("." + relatedProductsCl.product).querySelectorAll("." + relatedProductsCl.priceTag);
priceTags.forEach((tag)=>{
const tagMoneyEl = tag.querySelector(".money") || tag;
const previousPrice = tag.getAttribute("data-total-price");
if (tag.hasAttribute("original-price")) {
tag.setAttribute("data-total-price", chosenVariant.getAttribute("data-variant-original-price"));
tag.setAttribute("data-product-price", chosenVariant.getAttribute("data-variant-original-price"));
tag.setAttribute("data-product-price-currency", chosenVariant.getAttribute("data-variant-original-price-currency"));
tagMoneyEl.textContent = tagMoneyEl.textContent.replace(previousPrice, tag.getAttribute("data-product-price"));
return;
}
tag.setAttribute("data-total-price", chosenVariant.getAttribute("data-variant-price"));
tag.setAttribute("data-product-price", chosenVariant.getAttribute("data-variant-price"));
tag.setAttribute("data-product-price-currency", chosenVariant.getAttribute("data-variant-price-currency"));
tagMoneyEl.textContent = tagMoneyEl.textContent.replace(previousPrice, tag.getAttribute("data-product-price"));
});
};
const enableQuantityAndBasket = function(radio) {
const productWrapper = radio.closest("." + relatedProductsCl.product);
const quantityWrapper = productWrapper.querySelector("." + relatedProductsCl.quantityInputWrapper);
const quantityInput = quantityWrapper.querySelector("input");
quantityInput.setAttribute("data-chosen-variant-inventory", radio.getAttribute("data-variant-inventory"));
quantityInput.setAttribute("max", radio.getAttribute("data-variant-inventory"));
quantityInput.value = 1;
quantityInput.setAttribute("value", 1);
};
const updateProductQuantity = function(quantityInput, action = "plus") {
const currentQuantity = +quantityInput.value;
let newQuantity;
if (action === "plus") {
newQuantity = currentQuantity + 1;
quantityInput.value = newQuantity;
quantityInput.setAttribute("value", newQuantity);
calculatePriceTag(quantityInput.closest("." + relatedProductsCl.product));
} else if (action === "minus" && currentQuantity > 1) {
newQuantity = currentQuantity - 1;
quantityInput.value = newQuantity;
quantityInput.setAttribute("value", newQuantity);
calculatePriceTag(quantityInput.closest("." + relatedProductsCl.product), "minus");
} else if (action === "manual") {
newQuantity = currentQuantity;
quantityInput.value = newQuantity;
quantityInput.setAttribute("value", newQuantity);
calculatePriceTag(quantityInput.closest("." + relatedProductsCl.product), "manual", newQuantity);
}
};
const calculatePriceTag = function(product, action = "plus", quantity = 1) {
const priceTags = product.querySelectorAll("." + relatedProductsCl.priceTag);
const renderNewPrice = function(priceTag, previousTotalStr, newTotal) {
const tagMoneyEl = priceTag.querySelector(".money") || priceTag;
priceTag.setAttribute("data-total-price", newTotal.toFixed(2));
tagMoneyEl.textContent = tagMoneyEl.textContent.replace(previousTotalStr, newTotal.toFixed(2));
};
priceTags.forEach((tag)=>{
const previousTotalStr = tag.getAttribute("data-total-price");
const previousTotal = +tag.getAttribute("data-total-price");
const productPrice = +tag.getAttribute("data-product-price");
let newTotal;
if (action === "plus") {
newTotal = previousTotal + productPrice * quantity;
renderNewPrice(tag, previousTotalStr, newTotal);
} else if (action === "minus") {
newTotal = previousTotal - productPrice * quantity;
renderNewPrice(tag, previousTotalStr, newTotal);
} else if (action === "manual") {
newTotal = productPrice * quantity;
renderNewPrice(tag, previousTotalStr, newTotal);
}
});
};
const showRelatedProductsPopup = function(popup) {
popup.setAttribute("active", "");
};
const hideRelatedProductsPopup = function(popup) {
popup.removeAttribute("active");
};
const addRelatedProductsEvents = function(relatedProductsPopup) {
const relatedProductsWrapper = document.querySelector("." + relatedProductsCl.wrapper);
relatedProductsWrapper.addEventListener("click", (e)=>{
if (e.target.classList.contains(relatedProductsCl.cardBtn)) showRelatedProductsPopup(relatedProductsPopup);
});
relatedProductsPopup.addEventListener("click", (e)=>{
if (!relatedProductsPopup.hasAttribute("active")) return;
if (e.target.closest("button." + relatedProductsCl.popupCloseBtn) || e.target.classList.contains(relatedProductsCl.popupOverlay)) hideRelatedProductsPopup(relatedProductsPopup);
if (e.target.closest("." + relatedProductsCl.radio)) {
const radioInput = e.target.closest("." + relatedProductsCl.radio).querySelector("input");
if (radioInput.hasAttribute("out-of-stock")) return;
enableQuantityAndBasket(radioInput);
switchPriceTag(radioInput);
}
if (e.target.closest("." + relatedProductsCl.quantityPlusBtn)) updateProductQuantity(e.target.closest("." + relatedProductsCl.quantityInputWrapper).querySelector("input"));
if (e.target.closest("." + relatedProductsCl.quantityMinusBtn)) updateProductQuantity(e.target.closest("." + relatedProductsCl.quantityInputWrapper).querySelector("input"), "minus");
});
relatedProductsPopup.querySelectorAll("." + relatedProductsCl.quantityInputWrapper).forEach((input)=>{
input.querySelector("input").addEventListener("keyup", (e)=>{
if (e.target.value < 1) e.target.value = 1;
updateProductQuantity(e.target, "manual");
});
});
};
const popup = document.querySelector('.related-products-popup-js');
if (popup && document.querySelector('.related-products-wrapper-js')) addRelatedProductsEvents(popup);
})();

/* Countdown preserved from old bundle; UI updates once per second. */
(()=>{
function getTimeRemaining(endtime) {
const total = Date.parse(endtime) - Date.parse(new Date());
const seconds = Math.floor(total / 1000 % 60);
const minutes = Math.floor(total / 1000 / 60 % 60);
const hours = Math.floor(total / 3600000 % 24);
const days = Math.floor(total / 86400000);
return {
total,
days,
hours,
minutes,
seconds
};
}
function countdownVisibility(today, schedule, deadline) {
let visibility = true;
let weekend = false;
if (today.getDay() === 0 || today.getDay() === 6) weekend = true;
let shortToday = today;
let ye = new Intl.DateTimeFormat("en", {
year: "numeric"
}).format(today);
let mo = new Intl.DateTimeFormat("en", {
month: "2-digit"
}).format(today);
let da = new Intl.DateTimeFormat("en", {
day: "2-digit"
}).format(today);
shortToday = `${da}/${mo}/${ye}`;
let preMid = new Date(today);
let postMid = new Date(today);
preMid.setHours(23, 59, 59, 0);
postMid.setHours(0, 0, 1, 0);
const currentTimeMilliseconds = new Date(today).getTime();
const preMidMilliseconds = new Date(preMid).getTime();
const postMidMilliseconds = new Date(postMid).getTime();
const deadlineMilliseconds = new Date(deadline).getTime();
if (schedule.includes(shortToday)) visibility = false;
else if (weekend) visibility = false;
else {
if (currentTimeMilliseconds > deadlineMilliseconds && currentTimeMilliseconds < preMidMilliseconds) visibility = false;
if (currentTimeMilliseconds > postMidMilliseconds && currentTimeMilliseconds < deadlineMilliseconds) visibility = true;
}
return visibility;
}
function initializeClock(el, deadline, schedule, today) {
const visibility = countdownVisibility(today, schedule, deadline);
if (!visibility) el.style.display = "none";
const timeinterval = setInterval(()=>{
const t = getTimeRemaining(deadline);
const output = el.querySelector("span.countdown-js");
output.innerHTML = "Order in " + t.hours + " hours " + t.minutes + " minutes and " + t.seconds + " seconds";
if (t.total <= 0) clearInterval(timeinterval);
}, 1000);
}
const clock = document.querySelector('[data-countdown="active"]');
if (clock) {
 const schedule=(clock.getAttribute('data-holidays')||'').split(',');
 const now=new Date(),deadline=new Date(now); deadline.setHours(22,0,0,0);
 initializeClock(clock,deadline,schedule,now);
}
})();
